import React from "react";
import {
  Box,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import './agingCard.css';
const AgingAnalysisCard = ({
  ageingData = [],
  showEmptyGrey = false,
  EMPTY_DATA = [],
  EMPTY_COLOR = ["#ccc"],
  COLORS = [],
  totalValue = 0,
  items = [],
}) => {
  const dataToShow = showEmptyGrey ? EMPTY_DATA : ageingData;

  return (
    <Box className="card aging-analysis-card" p={2} borderRadius={2}>
      <Typography variant="h6" mb={2}>
        Aging Analysis
      </Typography>

      <Stack direction="row" spacing={3}>
        <Box width={150} height={150}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={dataToShow}
                cx="50%"
                cy="50%"
                outerRadius={60}
                innerRadius={35}
                dataKey="value"
                paddingAngle={2}
              >
                {dataToShow.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={
                      showEmptyGrey
                        ? EMPTY_COLOR[0]
                        : COLORS[index % COLORS.length]
                    }
                  />
                ))}
              </Pie>
              <Tooltip formatter={(value) => `₹ ${value.toLocaleString('en-IN')}}`} />
            </PieChart>
          </ResponsiveContainer>
        </Box>

        <Stack spacing={1} justifyContent="center" flex={1}>
          <Typography variant="body2" fontWeight="bold">
            Total: ₹ {totalValue}
          </Typography>
          <Divider />
          {items.map((item, idx) => (
            <Stack
              key={idx}
              direction="row"
              alignItems="center"
              spacing={1.5}
            >
              <Box
                width={10}
                height={10}
                borderRadius="50%"
                bgcolor={item.color}
              />
              <Typography variant="body2" flex={1}>
                {item.name}
              </Typography>
              <Typography variant="body2">({item.value.toLocaleString('en-IN')})</Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default AgingAnalysisCard;
// import React from "react";
// import { Typography } from "@mui/material";
// import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
// import './agingCard.css';
// // Props expected:
// // ageingData, showEmptyGrey, EMPTY_DATA, EMPTY_COLOR, COLORS, totalValue, items

// const AgingAnalysisCard = ({
//   ageingData = [],
//   showEmptyGrey = false,
//   EMPTY_DATA = [],
//   EMPTY_COLOR = ["#ccc"],
//   COLORS = [],
//   totalValue = 0,
//   items = [],
// }) => {
//   const dataToShow = showEmptyGrey ? EMPTY_DATA : ageingData;

//   return (
//     <div className="card aging-analysis-card">
//       <Typography className="chart-title">Aging Analysis</Typography>
//       <div className="aging-content">
//         <div className="aging-chart-wrapper">
//           <ResponsiveContainer width={150} height={150}>
//             <PieChart>
//               <Pie
//                 data={dataToShow}
//                 cx="50%"
//                 cy="50%"
//                 outerRadius={60}
//                 label={false}
//                 dataKey="value"
//               >
//                 {dataToShow.map((entry, index) => (
//                   <Cell
//                     key={`cell-${index}`}
//                     fill={
//                       showEmptyGrey
//                         ? EMPTY_COLOR[0]
//                         : COLORS[index % COLORS.length]
//                     }
//                   />
//                 ))}
//               </Pie>
//             </PieChart>
//           </ResponsiveContainer>
//         </div>
//         <div className="aging-bucket-stepper">
//           <div>
//             <div
//               style={{
//                 fontWeight: "normal",
//                 marginBottom: "10px",
//                 fontSize: "14px",
//               }}
//             >
//               Total: ₹ {totalValue}
//             </div>

//             {items.map((item, idx, arr) => (
//               <div
//                 className="stepper-item"
//                 key={idx}
//                 style={{ display: "flex", alignItems: "center", gap: "8px" }}
//               >
//                 {idx !== 0 && <div className="line-up"></div>}
//                 <div
//                   className="stepper-dot"
//                   style={{ backgroundColor: item.color }}
//                 ></div>
//                 <span className="stepper-label">{item.name}</span>
//                 <span className="stepper-value" style={{ fontSize: "14px" }}>
//                   ({item.value})
//                 </span>
//                 {idx !== arr.length - 1 && <div className="line-down"></div>}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AgingAnalysisCard;
